import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { RaceResultsResponse } from '../../../hooks';

type Data = Nullish<Omit<RaceResultsResponse, 'type'>>;
type State = {
  data: Data;
  setData: (data: Data) => void;
  resetData: () => void;
};

const INITIAL_STORE_VALUE: Omit<State, 'setData' | 'resetData'> = {
  data: null,
};

export type GameResultStore = State;

export const useGameResultStore = create<State>()(
  immer((set) => ({
    ...INITIAL_STORE_VALUE,
    setData: (data) =>
      set((state) => {
        state.data = data;
      }),
    resetData: () =>
      set((state) => {
        state.data = null;
      }),
  }))
);
